import Sidebar from "./ui/Sidebar";
import Navbar from "./ui/Navbar";
import { Route, Switch, useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import Transactions from "./transactions/Transactions";
import ConfirmPopup from './common/ConfirmPopup';

const TransactionPortal = () => {
    let history = useHistory();

    useSelector(state => {
        let accessToken = state.auth.accessToken;
        if (accessToken === null) {
            history.push('/login');
            return;
        }
        let role = state.auth.role 
        if (role !== "Admin") {
            history.push('/');
            return;
        }
    });

    return (
        <div className="wrapper">
            <Sidebar />

            <div className="main">
                <Navbar />

                <div className="content">
                    <Switch>
                        <Route path="/transactions" component={Transactions} />
                    </Switch>
                </div>


                <div className="footer">
                </div>

                <ConfirmPopup />
            </div>


        </div>
    );
};

export default TransactionPortal;

